
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M4.99979 13.18V15.99C4.99979 16.72 5.39979 17.4 6.03979 17.75L11.0398 20.48C11.6398 20.81 12.3598 20.81 12.9598 20.48L17.9598 17.75C18.5998 17.4 18.9998 16.72 18.9998 15.99V13.18L12.9598 16.48C12.3598 16.81 11.6398 16.81 11.0398 16.48L4.99979 13.18ZM11.0398 3.52003L2.60979 8.12003C1.91979 8.50003 1.91979 9.50003 2.60979 9.88003L11.0398 14.48C11.6398 14.81 12.3598 14.81 12.9598 14.48L20.9998 10.09V16C20.9998 16.55 21.4498 17 21.9998 17C22.5498 17 22.9998 16.55 22.9998 16V9.59003C22.9998 9.22003 22.7998 8.89003 22.4798 8.71003L12.9598 3.52003C12.3598 3.20003 11.6398 3.20003 11.0398 3.52003Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-school`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconSchool

    ```js
    <b-new-b-icon-school />
    ```
</docs>


